// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f8bd2e08","239":"42ddf4ab","732":"256f478c"}[chunkId] + ".chunk.js";
};